<template>
  <div class="disorder-teaser">
    <h2>{{ disorder.name }}</h2>
    <div class="disorder-teaser__text" v-html="disorder.body" />
    <router-link
      :to="`conditions/${disorder.slug }`"
      class="disorder-teaser__link"
    >
      Visit condition page
      <icon-component
        name="caret"
        class="disorder-teaser__link-icon icon--smallest"
      />
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'DisorderTeaser',
  components: {
  },
  props: {
    disorder: {
      type: Object,
      required: true,
    },
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_disorder-teaser';
</style>
